import React from "react";
import styled from "styled-components";

import {
  ColorType,
  Container,
  EqualHStack,
  VerticalStack,
} from "@components/Layout";
import { Title, Paragraph } from "@components/Text";
import { ProfileCard, SOCIAL_ICONS } from "@components/Cards";

const FamilyGrid = styled(EqualHStack)`
  max-width: 900px;
`;

const family = [
  {
    imgUrl: "./images/family/uwucrew.png",
    title: "uwucrew",
    socials: [
      {
        url: "https://opensea.io/collection/uwucrew",
        icon: SOCIAL_ICONS.OPENSEA,
      },
      {
        url: "https://twitter.com/uwucrewnft",
        icon: SOCIAL_ICONS.TWITTER,
      },
      {
        url: "https://uwucrew.art/",
        icon: SOCIAL_ICONS.WEBSITE,
      },
    ],
    description:
      "Kusari’s genesis - uwucrew is our first onchain art collection, published on Sep 2021.",
  },
  {
    imgUrl: "./images/family/killergf.png",
    title: "Killer GF",
    socials: [
      {
        url: "https://opensea.io/collection/killergf",
        icon: SOCIAL_ICONS.OPENSEA,
      },
      {
        url: "https://twitter.com/killergfnft",
        icon: SOCIAL_ICONS.TWITTER,
      },
      {
        url: "https://killergf.com/",
        icon: SOCIAL_ICONS.WEBSITE,
      },
    ],
    description:
      "Killer GF is our most popular onchain art collection, illustrated by an Ex-Riot Games Concept Artist.",
  },
  {
    imgUrl: "./images/family/killerkitties.webp",
    title: "Killer Kitties",
    socials: [
      {
        url: "https://opensea.io/collection/killerkitties",
        icon: SOCIAL_ICONS.OPENSEA,
      },
      {
        url: "https://twitter.com/killergfnft",
        icon: SOCIAL_ICONS.TWITTER,
      },
      {
        url: "https://killergf.com/",
        icon: SOCIAL_ICONS.WEBSITE,
      },
    ],
    description:
      "Killer Kitties is the sequel collection to Killer GF, made to reward the holders and expand the story!",
  },
  {
    imgUrl: "./images/family/waifusion.png",
    title: "Waifusion",
    socials: [
      {
        url: "https://opensea.io/collection/waifusion",
        icon: SOCIAL_ICONS.OPENSEA,
      },
      {
        url: "https://twitter.com/uwucrewnft",
        icon: SOCIAL_ICONS.TWITTER,
      },
      {
        url: "https://waifusion.io",
        icon: SOCIAL_ICONS.WEBSITE,
      },
    ],
    description:
      "With a community takeover in March 2021, Waifusion is where Kusari's onchain art journey began.",
  },
];

const Family = () => {
  return (
    <Container colorType={ColorType.SECONDARY} id="family">
      <VerticalStack>
        <Title>Kusari Family</Title>
        <Paragraph>
          The Family consists of our communities that help us connect with artists all over the globe and inspire them to create onchain. 
        </Paragraph>
        <FamilyGrid isWrap={true} columns={2}>
          {family.map((member) => (
            <ProfileCard
              key={member.title}
              imgUrl={member.imgUrl}
              title={member.title}
              socials={member.socials}
            >
              {member.description}
            </ProfileCard>
          ))}
        </FamilyGrid>
      </VerticalStack>
    </Container>
  );
};

export default Family;
